// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Load voice upload language list
// 2. Separation of Concerns - API first, static JSON fallback
// 3. Modular Architecture - Shared by VoiceUploadModal + TranslationGlossarySettings
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

import { apiClient, API_ENDPOINTS } from '../config/api';

/**
 * Voice upload languages: backend catalog first, then /config/voice_language.json.
 * Ensures production matches server support even if dist omits or ages static JSON.
 *
 * @returns {Promise<Array<{ code: string, name: string, default?: boolean }>>}
 */
export async function fetchVoiceUploadLanguages() {
  try {
    const res = await apiClient.get(API_ENDPOINTS.VOICE_UPLOAD_LANGUAGES);
    const payload = res.data?.data?.languages ?? res.data?.languages;
    if (Array.isArray(payload) && payload.length > 0) {
      return payload;
    }
  } catch (e) {
    console.warn(
      '[voiceLanguageConfig] API upload-languages failed, using static JSON',
      e?.message || e
    );
  }

  const r = await fetch('/config/voice_language.json');
  if (!r.ok) {
    throw new Error(`voice_language.json HTTP ${r.status}`);
  }
  const data = await r.json();
  return data.languages || [];
}
